/* eslint-disable */

export default {
  name: 'PayHandle',
  created() {
    console.error('->', this.$route.query)
    let result = this.$route.query
    this.success = result.r === '1'
    this.orderNo = result.orderNo
    if (this.success) {
      this.msg = '支払いに成功しました'
    } else {
      this.errMsg = decodeURIComponent(decodeURIComponent(result.msg)) || ''
    }

    let _this = this;
    let downTime = setInterval(() => {
      _this.count--;
      if (_this.count == 0) {
        clearInterval(downTime);
        this.close();
      }
    }, 1000)
  },
  data() {
    return {
      success: false,
      msg: '支払いに失敗しました',
      errMsg: '',
      count: 15,
      orderNo: ''
    }
  },
  methods: {
    close() {
      this.tryCloseOrRedirect('/pay')
    },
    tryCloseOrRedirect(fallbackUrl) {
      // 尝试打开当前窗口的上下文（部分浏览器允许关闭）
      const win = window.open('', '_self');

      // 尝试关闭窗口
      win.close();

      // 延迟检测关闭是否成功，如果失败就跳转
      setTimeout(function () {
        if (!window.closed) {
          // 关闭失败，跳转到备用地址
          window.location.href = fallbackUrl;
        }
      }, 100);
    }

  }
}